import axios from 'axios';
import { apiBaseUrl } from '../config';

// ── Public ─────────────────────────────────────────────────────────────────

export const listCourses = () =>
  axios.get(`${apiBaseUrl}/courses`, { withCredentials: true });

export const getCourseById = (id) =>
  axios.get(`${apiBaseUrl}/courses/${id}`, { withCredentials: true });

// ── Admin ──────────────────────────────────────────────────────────────────

const adminHeaders = (token) => ({ headers: { Authorization: `Bearer ${token}` }, withCredentials: true });

export const adminListCourses = (token) =>
  axios.get(`${apiBaseUrl}/admin/course/list`, adminHeaders(token));

export const adminGetCourse = (token, id) =>
  axios.get(`${apiBaseUrl}/admin/course/${id}`, adminHeaders(token));

export const adminCreateCourse = (token, data) =>
  axios.post(`${apiBaseUrl}/admin/course`, data, adminHeaders(token));

export const adminUpdateCourse = (token, id, data) =>
  axios.put(`${apiBaseUrl}/admin/course/${id}`, data, adminHeaders(token));

export const adminDeleteCourse = (token, id) =>
  axios.delete(`${apiBaseUrl}/admin/course/${id}`, adminHeaders(token));

export const adminUploadCourseImage = (token, file, onProgress) => {
  const form = new FormData();
  form.append('image', file);
  return axios.post(`${apiBaseUrl}/admin/course/uploadimage`, form, {
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
    withCredentials: true,
    onUploadProgress: onProgress,
  });
};
